(function () {
    $(document).on('ready', function(){

        /*** transitions FancyBox resizeIn ****/
        (function(f,b){b.transitions.resizeIn=function(){var c=b.previous,a=b.current,d=c.wrap.stop(!0).position(),e=f.extend({opacity:1},a.pos);d.width=c.wrap.width();d.height=c.wrap.height();c.wrap.stop(!0).trigger("onReset").remove();delete e.position;a.inner.hide();a.wrap.css(d).animate(e,{duration:a.nextSpeed,easing:a.nextEasing,step:b.transitions.step,complete:function(){b._afterZoomIn();a.inner.fadeIn("fast")}})}})(jQuery,jQuery.fancybox);


        if(window.FastClick)window.FastClick.attach(document.body);


        function isOnScreen ($elt, cbTrue, cbFalse, viewport) {
            var bounds = $elt.offset();
            bounds.right = bounds.left + $elt.outerWidth();
            bounds.bottom = bounds.top + $elt.outerHeight();
            bounds.bottom -= 100;

            var isOnScreen = (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

            return isOnScreen ? cbTrue && cbTrue(viewport, bounds) : cbFalse && cbFalse(viewport, bounds);
        };



        function checkInViewportElements(){
            var win = $(window);

            var viewport = {
                top : win.scrollTop(),
                left : win.scrollLeft()
            };
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();

            $('.viewport-wait').each(function(){
                var $e = $(this);

                console.log('$e', $e);
                isOnScreen($e, function(){
                    $e.addClass('is-in-viewport');
                }, function(){
                    $e.removeClass('is-in-viewport');
                }, viewport);
            }) ;
        }



        //FIXED MENU
        var oldScrollValue = 0;
        var checkMenuMode = function (e) {
            var offset = 140;
            var scroll = $(document).scrollTop();

            if (!$('body').hasClass('is-menu-open')) {
                if ((scroll > oldScrollValue) && (scroll > offset + 50)) {
                    if (!$('body').hasClass('is-menu-todown')) $('body').addClass('is-menu-todown');
                } else {
                    if ($('body').hasClass('is-menu-todown')) $('body').removeClass('is-menu-todown');
                }
            } else {
                $('body').removeClass('is-menu-todown');
            }

            oldScrollValue = scroll;
        };


        $(window).on('scroll resize', function(){
            checkInViewportElements();
            checkMenuMode();
        });
        $(window).trigger('resize');

        $(document).on('click', '#menu-icon', function(e){
            $('body').removeClass('is-menu-todown');
            $('body').toggleClass('is-menu-open');
            oldScrollValue = 0;
            $(window).trigger('resize');
        });


        $('[data-parallax]').parallax();


        $(document).on('focus', 'input, textarea', function(e){
            $(this).parents('.form-group').addClass('is-focus');
        });
        $(document).on('blur check', 'input, textarea', function(e){
            if($(this).val() == ''){
                $(this).parents('.form-group').removeClass('is-focus');
            }else{
                $(this).parents('.form-group').addClass('is-focus');
            }
        });
        $('input, textarea').trigger('check');





        $(document).on('mouseover', '.lieux__item img', function(){
            $(this).parent().addClass('is-active');
        });
        $(document).on('mouseout', '.lieux__item img', function(){
            $(this).parent().removeClass('is-active');
        });


        if($('.home-slider').length > 0){

            $('.home-slider__slider').slick({
                autoplay : true,
                autoplaySpeed : 7000,
                arrows : false,
                speed : 1000,
                cssEase : 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                lazyLoad : 'progressive'
            });
        }


    });

})();


//callback Gmaps Async
function initializeGmaps(){
    $(window).trigger('gmapLoaded');
}

//# sourceMappingURL=bundle.js.map